import { render, staticRenderFns } from "./ImageQuestion.vue?vue&type=template&id=91a1a3aa&scoped=true&"
import script from "./ImageQuestion.vue?vue&type=script&lang=js&"
export * from "./ImageQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ImageQuestion.vue?vue&type=style&index=0&id=91a1a3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a1a3aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VBtn,VFileInput})
